module.exports = __webpack_public_path__ + "media/react/gre/adaptive_prep_v2/assets/notes_icon_zero-2e58ea50619bb035293962acf26f51ce.svg";